
const GuidesTemplates = () => (
  <div className="pt-24 px-6 max-w-7xl mx-auto">
    <h1 className="text-4xl font-bold mb-8">Guides & Templates</h1>
    <p>Download guides and templates for employee recognition programs.</p>
  </div>
);

export { Page }

function Page() {
  return <GuidesTemplates />;
}
